module.exports = __webpack_public_path__ + "img/my-logo.bc687f1a.png";